import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Contractor, SetContractorAssignee } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseMutationOptions<Contractor, Error, SetContractorAssignee>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useSetContractorAssigneeRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<Contractor, Error, SetContractorAssignee>(
    [Entities.Contractors, 'set-assignee', id],
    async (payload: SetContractorAssignee) => {
      const { data } = await api.v1AdminContractorsContractorIdAssigneePut(id, payload)
      return data as Contractor
    },
    options,
  )
}
